import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";
import useFetch from '../../../api/api';

import { Button, List, ListItem, ListItemText, Paper, Stack, Typography } from "@mui/material"

import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import CheckIcon from '@mui/icons-material/Check';

import config from '../../../common/Config';

const Subscribe = (props) => {
	const navigate		= useNavigate()
	const privateFetch 	= useFetch()

	const [hasActiveSubscription, setHasActiveSubscription] = useState(false)
	
	useEffect(() => {
		privateFetch(config.apiUrl +"/subscription")
		.then((result) => result.json())
		.then((result) => {
			setHasActiveSubscription(result.success)
		})
	}, [])

	return (
		<Stack direction='column' m={1} justifyContent={'center'}>
			<Typography variant='h2' align="center" margin={2} fontWeight={900}>
				{props.title ? props.title : 'Faça parte do grupo dos melhores investidores!'}
			</Typography>
		
			<Stack direction='row' spacing={5}>
				<Paper sx={{width: '100%', p: 2}} elevation={4}>
					<Typography variant="h5" fontWeight={'bold'}>Acesso Básico</Typography>
					<Stack direction='column'>
						<List>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Acesso a mais de 5000 ativos do Brasil e do Mundo</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Dados Financeiros</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Histórico de Dividendos</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Comunidade</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Gerenciador de Portfólio</ListItemText>
							</ListItem>	
							<ListItem>
								<DoNotDisturbIcon sx={{color: "red", pr: 2}}/>
								<ListItemText>Acesso às estratégias de investimento</ListItemText>
							</ListItem>
							<ListItem>
								<DoNotDisturbIcon sx={{color: "red", pr: 2}}/>
								<ListItemText>Estratégias de investimento personalizadas</ListItemText>
							</ListItem>
							<ListItem>
								<DoNotDisturbIcon sx={{color: "red", pr: 2}}/>
								<ListItemText>Discussões sobre estratégias de investimento</ListItemText>
							</ListItem>																															
						</List>
					</Stack>
				</Paper>
				<Paper sx={{width: '100%', p: 2}} elevation={4}>
					<Typography variant="h5" fontWeight={'bold'}>Acesso Completo</Typography>
					<Stack direction='column'>
						<List>
						<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Acesso a mais de 5000 ativos do Brasil e do Mundo</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Dados Financeiros</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Histórico de Dividendos</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Comunidade</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: 'green', pr: 2}}/>
								<ListItemText>Gerenciador de Portfólio</ListItemText>
							</ListItem>	
							<ListItem>
								<CheckIcon sx={{color: "green", pr: 2}}/>
								<ListItemText>Acesso às estratégias de investimento</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: "green", pr: 2}}/>
								<ListItemText>Estratégias de investimento personalizadas</ListItemText>
							</ListItem>
							<ListItem>
								<CheckIcon sx={{color: "green", pr: 2}}/>
								<ListItemText>Discussões sobre estratégias de investimento</ListItemText>
							</ListItem>
						</List>

						<Button variant="contained" onClick={() => navigate(hasActiveSubscription ? '/subscription' : '/subscription/new')}>
							Assine Agora!
						</Button>
					
					</Stack>
				</Paper>
			</Stack>
		</Stack>
	)
}

export default Subscribe